import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Button, List, ListItem, ListItemText, Card, CardContent, Grid, Modal, TextField } from '@mui/material';
import Nlayout from './Nlayout';
import axios from 'axios';
import backgroundImg from './main_intro.jpg';
import { motion, AnimatePresence } from 'framer-motion';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { useAuth } from './authContext';
import io from 'socket.io-client';
import { FaFacebook } from "react-icons/fa";
import { FaDiscord } from "react-icons/fa";
import { FaYoutube } from 'react-icons/fa6';
import { v4 as uuidv4 } from 'uuid';
import { getEnhancedFingerprint } from './fingerprint';
import { launchApp, isMobileDevice, isInsideAppWebView } from './utils/appLauncher';
const socket = io('https://socket.eldenguee.com', {
  transports: ['websocket', 'polling'],
});

export default function DetalleSorteo({ sorteos, setSorteos, isMobile }) {
  const { url } = useParams();
  const { username, logout } = useAuth();
  const currentLoggedUser = String(localStorage.getItem('kick_user') || username || '').trim().toLowerCase();
  const currentLoggedMail = String(localStorage.getItem('kick_mail') || '').trim().toLowerCase();
  const jwtToken = localStorage.getItem('kick_jwt') || localStorage.getItem('session_token') || localStorage.getItem('accessToken') || '';
  const esMasterAdmin = (
    ['eldenguee', 'lucaslunacl'].includes(currentLoggedUser) ||
    ['lucaslunaclaraso@gmail.com', 'chinosc.96@gmail.com', 'eldenguee@gmail.com'].includes(currentLoggedMail)
  ) && Boolean(jwtToken);
  const [isFromFacebook, setIsFromFacebook] = useState(false);
  const [sorteo, setSorteo] = useState();
  const [participantes, setParticipantes] = useState();
  const [ganadores, setGanadores] = useState();
  const [unirseSorteo, setUnirseSorteo] = useState();
  const [messageCounts, setMessageCounts] = useState({});
  const [currentRaffleId, setCurrentRaffleId] = useState(url);
  // ==== NUEVO ESTADO PARA TIPO "ID" ====
  const [participanteId, setParticipanteId] = useState('');
  // ==== ESTADOS PARA SORTEO MANUAL ====
  const [listaManual, setListaManual] = useState('');
  const [mostrarSorteoManual, setMostrarSorteoManual] = useState(false);
  const [fingerprint, setFingerprint] = useState('');   // ← NUEVO: guardamos el visitorId

  // Función para obtener el fingerprint mejorado
  const getFingerprint = async () => {
    try {
      const visitorId = await getEnhancedFingerprint();

      console.log('✅ Enhanced Fingerprint ID:', visitorId);
      setFingerprint(visitorId);

      // Guardamos también en localStorage como respaldo
      localStorage.setItem('userFingerprint_v2', visitorId);

      return visitorId;
    } catch (error) {
      console.error('❌ Error generando fingerprint:', error);
      return null;
    }
  };

  // Obtenemos el fingerprint al montar el componente
  useEffect(() => {
    getFingerprint();
  }, []);

  // Función auxiliar para obtener fingerprint (usa el estado o localStorage)
  const getOrCreateFingerprint = async () => {
    if (fingerprint) return fingerprint;

    const saved = localStorage.getItem('userFingerprint_v2');
    if (saved) {
      setFingerprint(saved);
      return saved;
    }

    return await getFingerprint();
  };

  const obtenerSorteos = async () => {
    const peticion = await axios.get(`https://backend.eldenguee.com/sorteo/${url}`);
    setSorteo(peticion?.data?.sorteo);
    setParticipantes(peticion?.data?.participantes);
    return peticion?.data?.sorteo;
  };

  const usuarioOBt = localStorage.getItem('kick_user');
  const [informacion, setInformacion] = useState()
  const infoUser = async () => {
    const res = await axios.get(`https://backend.eldenguee.com/solicitudes/usuarios/${usuarioOBt}`)
    setInformacion(res.data)
  }
  const getPublicIP = async () => {
    const res = await fetch('https://api.ipify.org?format=json');
    const data = await res.json();
    return data.ip;
  };

  const getOrCreateUUID = () => {
    let uuid = localStorage.getItem('userUUID');
    if (!uuid) {
      uuid = uuidv4();
      localStorage.setItem('userUUID', uuid);
    }
    return uuid;
  };
  const UnirseAlSorteo = async (nombreBase, mail, facebook, participante_id = null) => {

    try {
      const ip = await getPublicIP();
      const nombre = nombreBase;
      const uuid = getOrCreateUUID();
      const fp = await getOrCreateFingerprint();   // ← NUEVO
      const peticion = await axios.post(`https://backend.eldenguee.com/sorteo/${url}/unirse`, {
        nombre,
        mail,
        ip,
        uuid,
        participante_id, // ← nuevo: enviamos el ID separado
        fingerprint: fp
      });

      if (peticion?.data?.success) {
        setUnirseSorteo(true);
        setParticipanteId(''); // ← limpiamos el input después de unirse
        obtenerSorteos();
      } else {
        alert(peticion?.data?.error || 'No se pudo unir al sorteo.');
      }
    } catch (error) {
      console.error('Error al unirse al sorteo:', error);
      alert('Ocurrió un error al unirse.');
    }
  };

  const actualizar = () => {
    const usuarioKick = localStorage.getItem('kick_user');


    const searchParams = new URLSearchParams(window.location.search);
    const claveFb = searchParams.get('fb');

    if (usuarioKick && claveFb) {
      axios.post(`https://backend.eldenguee.com/sorteo/${url}/actualizar-fb`, {
        nombre: usuarioKick,
        facebook: true,
        clave: claveFb,
      }).catch((err) => {
        console.error('Error actualizando Facebook:', err);
      });
    }
  }
  const getYoutubeComments = async () => {
    const youtube = await obtenerSorteos()

    const match = youtube.video.match(/(?:v=|\/)([0-9A-Za-z_-]{11})/);
    const videoId = match ? match[1] : null;

    if (!videoId) {
      console.error('❌ No se pudo encontrar un videoId en el string:', youtube);
      return;
    }

    try {
      const response = await axios.get('https://www.googleapis.com/youtube/v3/commentThreads', {
        params: {
          part: 'snippet',
          videoId: videoId,
          key: API_KEY,
          maxResults: 50,
          order: 'time'
        }
      });

      const comments = response.data.items.map(item => item.snippet.topLevelComment.snippet.textDisplay);
      actualizarYoutubeDesdeComentario(comments)
    } catch (error) {
      console.error('Error al obtener comentarios:', error.response?.data || error.message);
    }
  };

  const actualizarYoutubeDesdeComentario = (comentarios) => {
    const usuarioKick = localStorage.getItem('kick_user');
    if (!usuarioKick) return;

    const nombre = usuarioKick.toLowerCase();
    const match = comentarios.find(comentario =>
      comentario.toLowerCase().includes(nombre)
    );

    if (match) {
      axios.post(`https://backend.eldenguee.com/sorteo/${url}/actualizar-youtube`, {
        nombre: usuarioKick,
        youtube: true
      }).catch((err) => {
        console.error('Error actualizando YouTube:', err);
      });
    }
  };

  useEffect(() => {
    obtenerSorteos();
    if (sorteo?.tipo === 'Suscriptores') {
      infoUser();
    }

    setTimeout(() => {
      actualizar()
    }, 3000)

  }, []);

  useEffect(() => {
    const referrer = document.referrer;
    if (referrer.includes('facebook.com')) {
      setIsFromFacebook(true);
    }
  }, []);

  const usuario = localStorage.getItem('fbUser')?.replaceAll('"', '');
  const usuarioKick = localStorage.getItem('kick_user');;
  const mailKick = localStorage.getItem('kick_mail');
  // const jwtToken = localStorage.getItem('kick_jwt')

  const unirse = () => {

    const nombreBase = localStorage.getItem('kick_user');;
    const mail = mailKick;
    if (!nombreBase) return;
    if (sorteo?.tipo === 'ID') {
      if (!participanteId.trim()) {
        alert('Debes ingresar un ID para participar.');
        return;
      }
    }

    UnirseAlSorteo(nombreBase, mail, isFromFacebook, sorteo?.tipo === 'ID' ? participanteId.trim() : null);
  };

  useEffect(() => {
    if (participantes?.length && usuarioKick) {
      const base = usuarioKick.toLowerCase();
      const isAlready = participantes.some(p => {
        const pName = p.nombre.toLowerCase();
        if (sorteo?.tipo === 'ID') {
          return pName === base || pName.startsWith(base + ' (');
        }
        return pName === base;
      });
      setUnirseSorteo(isAlready);
    }
  }, [participantes, username, sorteo?.tipo]);
  const guardarGanadores = async (url, ganadores) => {
    try {
      const candidateToken =
        localStorage.getItem('accessToken') ||
        localStorage.getItem('token') ||
        localStorage.getItem('session_token') ||
        localStorage.getItem('kick_jwt') ||
        '';
      const storedUser = localStorage.getItem('kick_user') || username || 'lucaslunacl';
      const headers = {
        'x-api-key': 'ed_qatar_2022_messi_dengueclarasoluna_2026',
        'x-internal-api-key': 'ed_qatar_2022_messi_dengueclarasoluna_2026',
        'X-Username': storedUser,
      };
      if (candidateToken) {
        headers['Authorization'] = `Bearer ${candidateToken}`;
        headers['X-Session-Token'] = candidateToken;
      }
      const response = await axios.put(`https://backend.eldenguee.com/sorteo/${url}/ganadores`, {
        ganadores,
        force: true,
        admin: storedUser,
        username: storedUser,
      }, { headers });
      return response.data;
    } catch (error) {
      console.error('Error al guardar ganadores:', error);
      throw error;
    }
  };

  const [open, setOpen] = useState();
  const [progress, setProgress] = useState(100);
  const duration = 5000;

  useEffect(() => {
    if (open) {
      setProgress(100);
      let interval = setInterval(() => {
        setProgress((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            if (open) {
              setOpen(false);
            }
            return 0;
          }
          return prev - 2;
        });
      }, duration / 50);
      return () => clearInterval(interval);
    }
  }, [open]);

  const obtenerGanadoresDelSorteoAnterior = async () => {
    try {
      const response = await fetch(`https://backend.eldenguee.com/sorteo/${url}/ganadores-anteriores`);
      const data = await response.json();
      return Array.isArray(data.ganadores) ? data.ganadores : [];
    } catch (err) {
      console.error('Error al obtener la blacklist:', err);
      return [];
    }
  };
  const obtenerBlackList = async () => {
    try {
      const response = await fetch(`https://backend.eldenguee.com/solicitudes/blacklist`);
      const data = await response.json();
      return Array.isArray(data) ? data : [];
    } catch (err) {
      console.error('Error al obtener la blacklist:', err);
      return [];
    }
  };
  const [previewMode, setPreviewMode] = useState(false);
  const [previewList, setPreviewList] = useState([]);

  // Función para verificar si un participante coincide con algún elemento de una lista (nombre o mail)
  const matchParticipante = (p, list) => {
    if (!list || !Array.isArray(list) || !p) return false;
    const pNombre = (p.nombre || '').trim().toLowerCase();
    const pNombreBase = pNombre.replace(/\s*\(.*?\)$/, '').trim();
    const pMail = (p.mail || '').trim().toLowerCase();

    return list.some(item => {
      if (!item) return false;
      if (typeof item === 'string') {
        const itemLower = item.trim().toLowerCase();
        return itemLower === pNombre || itemLower === pNombreBase || (pMail && itemLower === pMail);
      }
      if (typeof item === 'object') {
        const itemNombre = (item.nombre || item.username || item.user || '').trim().toLowerCase();
        const itemMail = (item.mail || item.email || '').trim().toLowerCase();
        return (
          (itemNombre && (itemNombre === pNombre || itemNombre === pNombreBase)) ||
          (itemMail && pMail && itemMail === pMail)
        );
      }
      return false;
    });
  };

  // Algoritmo Fisher-Yates para sorteo 100% aleatorio, puro y sin sesgo
  const shuffle = (array) => {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  };

  // Verificar si una cuenta de Kick tiene menos de 15 días de antigüedad
  const verificarCuentaKick = async (nombre) => {
    try {
      const response = await fetch(`https://kick.com/api/v2/channels/${nombre}`);
      if (!response.ok) return { nombre, esNueva: false };
      const data = await response.json();
      const createdAt = new Date(data.chatroom.created_at);
      const ahora = new Date();
      const diffDias = (ahora - createdAt) / (1000 * 60 * 60 * 24);
      return { nombre, esNueva: diffDias < 15, diffDias };
    } catch (error) {
      console.error(`Error verificando cuenta Kick de ${nombre}:`, error);
      return { nombre, esNueva: false };
    }
  };

  const sortear = async () => {
    if (!esMasterAdmin) {
      alert('Se requieren permisos de administrador (eldenguee o lucaslunacl) para realizar el sorteo.');
      return;
    }
    if (!participantes || participantes.length === 0) {
      alert('No hay participantes en el sorteo');
      return;
    }

    const ganadoresAnteriores = await obtenerGanadoresDelSorteoAnterior();
    const blackListReal = await obtenerBlackList();

    // Verificar antigüedad de cuentas de Kick (menos de 15 días = excluidas inicialmente)
    const verificaciones = await Promise.allSettled(
      participantes.map(p => verificarCuentaKick(p.nombre))
    );
    const cuentasNuevas = verificaciones
      .filter(r => r.status === 'fulfilled' && r.value.esNueva)
      .map(r => r.value.nombre);
    if (cuentasNuevas.length > 0) {
      console.log('⚠️ Cuentas con menos de 15 días (prioridad baja en el sorteo):', cuentasNuevas);
    }

    // Deduplicar participantes únicos preservando su objeto completo
    const participantesUnicosMap = new Map();
    participantes.forEach(p => {
      if (p && p.nombre) {
        const key = p.nombre.trim().toLowerCase();
        if (!participantesUnicosMap.has(key)) {
          participantesUnicosMap.set(key, p);
        }
      }
    });
    const participantesUnicos = Array.from(participantesUnicosMap.values());

    const totalPremios = Math.max(1, Number(sorteo?.premios) || 1);
    const targetGanadores = Math.min(totalPremios, participantesUnicos.length);

    // Clasificación en grupos de prioridad:
    // 1. Nuevos (limpios): No están en blacklist real, ni ganaron en el sorteo anterior, ni son cuentas nuevas
    // 2. Antiguos: Ganaron en el sorteo anterior, pero NO están en blacklist real ni son cuentas nuevas
    // 3. Blacklist: Están en la blacklist real (se usarán si faltan para completar el total de premios)
    // 4. Otros: Cuentas nuevas o participantes restantes
    const nuevos = [];
    const antiguos = [];
    const enBlacklist = [];
    const otros = [];

    participantesUnicos.forEach(p => {
      const esEnBLReal = matchParticipante(p, blackListReal);
      const esGanadorAnt = matchParticipante(p, ganadoresAnteriores);
      const esCuentaNueva = cuentasNuevas.some(cn => cn.toLowerCase() === (p.nombre || '').toLowerCase());

      if (esEnBLReal) {
        enBlacklist.push(p);
      } else if (esCuentaNueva) {
        otros.push(p);
      } else if (esGanadorAnt) {
        antiguos.push(p);
      } else {
        nuevos.push(p);
      }
    });

    let ganadoresSet = new Set();

    // 1. Prioridad: Nuevos / Limpios
    for (const p of shuffle(nuevos)) {
      if (ganadoresSet.size < targetGanadores) {
        ganadoresSet.add(p.nombre);
      } else break;
    }

    // 2. Prioridad: Antiguos (ganadores de sorteos anteriores)
    if (ganadoresSet.size < targetGanadores) {
      for (const p of shuffle(antiguos)) {
        if (ganadoresSet.size < targetGanadores) {
          ganadoresSet.add(p.nombre);
        } else break;
      }
    }

    // 3. Prioridad: Blacklist (si no alcanzan los participantes limpios, completar con blacklist para igualar la lista de premios)
    if (ganadoresSet.size < targetGanadores) {
      for (const p of shuffle(enBlacklist)) {
        if (ganadoresSet.size < targetGanadores) {
          ganadoresSet.add(p.nombre);
        } else break;
      }
    }

    // 4. Prioridad: Restantes / Cuentas nuevas si aún hicieran falta
    if (ganadoresSet.size < targetGanadores) {
      for (const p of shuffle(otros)) {
        if (ganadoresSet.size < targetGanadores) {
          ganadoresSet.add(p.nombre);
        } else break;
      }
    }

    // Garantía adicional: Si por cualquier razón ganadoresSet < targetGanadores, tomar de cualquier participante único
    if (ganadoresSet.size < targetGanadores) {
      for (const p of shuffle(participantesUnicos)) {
        if (ganadoresSet.size < targetGanadores) {
          ganadoresSet.add(p.nombre);
        } else break;
      }
    }

    const initialWinners = [...ganadoresSet].map(nombre =>
      participantesUnicos.find(p => p.nombre === nombre) || { nombre }
    );

    // 2. Detectar multicuentas entre los ganadores iniciales
    const multicuentasDetectadas = initialWinners.filter(ganador => {
      if (!ganador?.fingerprint) return false;
      const count = participantes.filter(p => p.fingerprint === ganador.fingerprint).length;
      return count > 1;
    });

    const numMultis = multicuentasDetectadas.length;

    // 3. Pool de reemplazos posibles:
    // Priorizamos participantes que tengan fingerprint único y no hayan ganado,
    // siguiendo el orden de prioridad: limpios -> antiguos -> blacklist -> otros.
    const ganadoresNombresLower = initialWinners.map(p => (p.nombre || '').toLowerCase());

    const filtrarCandidatosReemplazo = (pool) => {
      return pool.filter(p => {
        if (ganadoresNombresLower.includes((p.nombre || '').toLowerCase())) return false;
        if (!p.fingerprint) return true;
        const count = participantes.filter(x => x.fingerprint === p.fingerprint).length;
        return count === 1;
      });
    };

    const reemplazosCandidatos = [
      ...shuffle(filtrarCandidatosReemplazo(nuevos)),
      ...shuffle(filtrarCandidatosReemplazo(antiguos)),
      ...shuffle(filtrarCandidatosReemplazo(enBlacklist)),
      ...shuffle(filtrarCandidatosReemplazo(otros)),
    ];

    // Si no hay suficientes con fingerprint único, tomar de cualquier participante no ganador para no perder cupos de premios
    if (reemplazosCandidatos.length < numMultis) {
      const yaEnCandidatos = new Set(reemplazosCandidatos.map(p => (p.nombre || '').toLowerCase()));
      const restoDisponibles = shuffle(participantesUnicos.filter(p =>
        !ganadoresNombresLower.includes((p.nombre || '').toLowerCase()) &&
        !yaEnCandidatos.has((p.nombre || '').toLowerCase())
      ));
      reemplazosCandidatos.push(...restoDisponibles);
    }

    const replacements = reemplazosCandidatos.slice(0, numMultis);

    // 4. Lista para MOSTRAR en la vista previa
    const preview = [];

    // Ganadores normales (sin multi)
    initialWinners
      .filter(w => !multicuentasDetectadas.some(m => m.nombre === w.nombre))
      .forEach(w => preview.push({ ...w, isMulti: false, isReplacement: false }));

    // Multicuentas en rojo
    multicuentasDetectadas.forEach(m => {
      const otrosMC = participantes
        .filter(p => p.fingerprint === m.fingerprint && p.nombre !== m.nombre)
        .map(p => p.nombre)
        .join(', ');

      preview.push({
        ...m,
        isMulti: true,
        isReplacement: false,
        multiText: otrosMC ? ` (Multicuenta - ${otrosMC})` : ' (Multicuenta)'
      });
    });

    // Reemplazos en verde
    replacements.forEach((rep, index) => {
      const multiReemplazado = multicuentasDetectadas[index]?.nombre || 'multicuenta';
      preview.push({
        ...rep,
        isMulti: false,
        isReplacement: true,
        replacing: multiReemplazado
      });
    });

    // 5. Guardar ganadores válidos (sin multicuentas + con reemplazos)
    let cleanWinners = [
      ...initialWinners.filter(w => !multicuentasDetectadas.some(m => m.nombre === w.nombre)),
      ...replacements
    ];

    // Asegurar SIEMPRE que la lista final de ganadores sea igual a targetGanadores
    if (cleanWinners.length < targetGanadores) {
      const yaGanaronSet = new Set(cleanWinners.map(w => (w.nombre || '').toLowerCase()));
      const faltantes = shuffle(participantesUnicos.filter(p => !yaGanaronSet.has((p.nombre || '').toLowerCase())));
      for (const p of faltantes) {
        if (cleanWinners.length < targetGanadores) {
          yaGanaronSet.add((p.nombre || '').toLowerCase());
          cleanWinners.push(p);
        } else break;
      }
    }

    setPreviewList(preview);
    setPreviewMode(true);

    await guardarGanadores(url, cleanWinners.map(p => p.nombre));
    await obtenerSorteos();

    setGanadores(cleanWinners); // para el toast de ganador

    if (cleanWinners.some(p => p.nombre === usuarioKick)) {
      setOpen(true);
    }

    // La vista previa se oculta automáticamente después de 30 segundos
    setTimeout(() => setPreviewMode(false), 30000);
  };

  // ==== SORTEO MANUAL ====
  const sortearManual = async () => {
    if (!esMasterAdmin) {
      alert('Se requieren permisos de administrador (eldenguee o lucaslunacl) para realizar el sorteo.');
      return;
    }
    if (!listaManual.trim()) {
      alert('Pega la lista de participantes primero');
      return;
    }

    // 1. Obtenemos las listas de exclusión
    const ganadoresAnteriores = await obtenerGanadoresDelSorteoAnterior();
    const blackListReal = await obtenerBlackList();

    // 2. Procesamos la lista manual ingresada
    const nombresIngresados = listaManual
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0);

    if (nombresIngresados.length === 0) {
      alert('No se encontraron nombres válidos');
      return;
    }

    // Deduplicar nombres manuales preservando el formato original
    const nombresMap = new Map();
    nombresIngresados.forEach(nombre => {
      const lower = nombre.toLowerCase();
      if (!nombresMap.has(lower)) {
        nombresMap.set(lower, nombre);
      }
    });

    const nombresUnicos = Array.from(nombresMap.values());
    const totalPremios = Math.max(1, Number(sorteo?.premios) || 1);
    const targetGanadores = Math.min(totalPremios, nombresUnicos.length);

    // 3. Creamos objetos de participantes manuales
    const participantesManual = nombresUnicos.map(nombre => ({ nombre }));

    // 4. Clasificamos en los pools de prioridad
    const nuevos = [];
    const antiguos = [];
    const enBlacklist = [];

    participantesManual.forEach(p => {
      if (matchParticipante(p, blackListReal)) {
        enBlacklist.push(p);
      } else if (matchParticipante(p, ganadoresAnteriores)) {
        antiguos.push(p);
      } else {
        nuevos.push(p);
      }
    });

    // 5. Sorteo con prioridad: Limpios -> Antiguos -> Blacklist
    const ganadoresSet = new Set();

    // Prioridad 1: Nuevos (limpios)
    for (const p of shuffle(nuevos)) {
      if (ganadoresSet.size < targetGanadores) {
        ganadoresSet.add(p.nombre);
      } else break;
    }

    // Prioridad 2: Antiguos (ganadores de sorteos anteriores)
    if (ganadoresSet.size < targetGanadores) {
      for (const p of shuffle(antiguos)) {
        if (ganadoresSet.size < targetGanadores) {
          ganadoresSet.add(p.nombre);
        } else break;
      }
    }

    // Prioridad 3: Blacklist (completar los premios faltantes para igualar a la cantidad de premios)
    if (ganadoresSet.size < targetGanadores) {
      for (const p of shuffle(enBlacklist)) {
        if (ganadoresSet.size < targetGanadores) {
          ganadoresSet.add(p.nombre);
        } else break;
      }
    }

    // Garantía: Si aún faltaran para igualar la lista de premios
    if (ganadoresSet.size < targetGanadores) {
      for (const p of shuffle(participantesManual)) {
        if (ganadoresSet.size < targetGanadores) {
          ganadoresSet.add(p.nombre);
        } else break;
      }
    }

    // 6. Resultado final
    const ganadoresNombres = [...ganadoresSet];
    const ganadoresParaUI = ganadoresNombres.map(nombre => ({ nombre }));

    try {
      await guardarGanadores(url, ganadoresNombres);
      await obtenerSorteos();
      setGanadores(ganadoresParaUI);

      // Limpieza
      setListaManual('');
      setMostrarSorteoManual(false);

      if (ganadoresNombres.includes(usuarioKick)) {
        setOpen(true);
      }
    } catch (error) {
      alert('Error al guardar los ganadores');
      console.error(error);
    }
  };

  useEffect(() => {
    let intervalo;
    let yaMostrado = false;

    const verificarGanador = async () => {
      try {
        const peticion = await axios.get(`https://backend.eldenguee.com/sorteo/${url}/ganadores`);
        const data = peticion?.data;

        if (!yaMostrado && data?.some((ganador) => ganador === usuarioKick)) {
          setOpen(true);
          yaMostrado = true;
          clearInterval(intervalo);
        }
      } catch (error) {
        console.error('Error al verificar ganadores', error);
      }
    };

    intervalo = setInterval(verificarGanador, 5000);
    return () => clearInterval(intervalo);
  }, []);

  useEffect(() => {
    obtenerSorteos();

    const interval = setInterval(obtenerSorteos, 5000);
    return () => clearInterval(interval);
  }, [url]);

  const [mousePos, setMousePos] = useState({ x: -100, y: -100 });
  const svgRef = useRef(null);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setMousePos({ x, y });

    if (svgRef.current) {
      const ellipse = svgRef.current.querySelector('ellipse');
      if (ellipse) {
        ellipse.setAttribute('cx', `${x}%`);
        ellipse.setAttribute('cy', `${y}%`);
      }
    }
  };

  const handleMouseLeave = () => {
    setMousePos({ x: -100, y: -100 });
    if (svgRef.current) {
      const ellipse = svgRef.current.querySelector('ellipse');
      if (ellipse) {
        ellipse.setAttribute('cx', '1.25%');
        ellipse.setAttribute('cy', '82.24121557454892%');
      }
    }
  };

  const getUserColor = (messageCount) => {
    if (messageCount >= 200) return { color: '#ff0000cc', bonus: 10 };
    if (messageCount >= 150) return { color: '#ed6e07cc', bonus: 8 };
    if (messageCount >= 100) return { color: '#bec800cc', bonus: 6 };
    if (messageCount >= 45) return { color: '#33e64bcc', bonus: 4 };
    if (messageCount >= 15) return { color: '#008a13cc', bonus: 2 };
    return { color: 'black', bonus: 0 };
  };
  const API_KEY = 'AIzaSyBT5sflU58-ZF3vua_I5fFYbyAE13mTa3c';

  const obtenerConteoMensajes = async () => {
    try {
      const response = await axios.get(`https://backend.eldenguee.com/sorteo/${url}/conteo-mensajes`);
      setMessageCounts(response.data.counts || {});
    } catch (error) {
      console.error('Error al obtener conteo de mensajes:', error);
      setMessageCounts({});
    }
  };
  const [tiempoRestante, setTiempoRestante] = useState(45);

  useEffect(() => {
    obtenerConteoMensajes();
    const interval = setInterval(() => {
      obtenerConteoMensajes();
      getYoutubeComments();
      setTiempoRestante(45);
    }, 45000);

    return () => clearInterval(interval);
  }, [url]);

  useEffect(() => {
    const intervaloContador = setInterval(() => {
      setTiempoRestante((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(intervaloContador);
  }, []);

  useEffect(() => {
    const usuarioKick = localStorage.getItem('kick_user');;

    if (esMasterAdmin && sorteo?.tipo) {
      socket.connect();

      socket.on('connect', () => {
        console.log('Conectado al servidor:', socket.id);
        socket.emit('register-creator', { creatorId: '15789-52' });

        socket.emit('start-raffle', {
          raffleId: url,
          type: sorteo.tipo,
          keyword: sorteo.keyword
        });
      });

      socket.on('raffle-started', (data) => {
        console.log(data.message);
        setCurrentRaffleId(data.raffleId);
        setMessageCounts({});
      });
    }

    return () => {
      socket.off('connect');
      socket.off('raffle-started');
    };
  }, [sorteo, url]);

  // ── helpers ──────────────────────────────────────────────────────────────
  const [busqueda, setBusqueda] = useState('');
  const [mostrarTodosGanadores, setMostrarTodosGanadores] = useState(false);

  const getMedalColor = (index) => {
    if (index === 0) return '#FFD700';
    if (index === 1) return '#C0C0C0';
    if (index === 2) return '#CD7F32';
    return '#7c7c8e';
  };

  const getMedalEmoji = (index) => {
    if (index === 0) return '🥇';
    if (index === 1) return '🥈';
    if (index === 2) return '🥉';
    return null;
  };

  const getInitials = (nombre = '') => nombre.slice(0, 2).toUpperCase();

  const getAvatarGradient = (nombre = '') => {
    const colors = [
      ['#6c63ff', '#a855f7'], ['#f59e0b', '#ef4444'], ['#10b981', '#3b82f6'],
      ['#ec4899', '#8b5cf6'], ['#14b8a6', '#6366f1'], ['#f97316', '#eab308'],
    ];
    const idx = nombre.charCodeAt(0) % colors.length;
    return `linear-gradient(135deg, ${colors[idx][0]}, ${colors[idx][1]})`;
  };

  const ganadoresParsed = sorteo?.ganadores?.length
    ? JSON.parse(sorteo.ganadores || '[]').map(name => {
      const p = participantes?.find(pp => pp.nombre === name);
      return p || { nombre: name };
    })
    : [];

  const ganadoresDisplay = previewMode ? previewList : ganadoresParsed;
  const ganadoresVista = mostrarTodosGanadores ? ganadoresDisplay : ganadoresDisplay.slice(0, 10);

  const participantesFiltrados = participantes?.filter(p =>
    p.nombre.toLowerCase().includes(busqueda.toLowerCase())
  ) || [];

  // ── render ────────────────────────────────────────────────────────────────
  return (
    <Nlayout>
      {/* ── background animado ── */}
      <Grid
        className="backgroundAnimado"
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        style={{ width: '100%', minHeight: '100vh', padding: '80px 0 40px' }}
      >
        <svg
          ref={svgRef}
          xmlns="http://www.w3.org/2000/svg"
          width="1920" height="1234" fill="none"
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}
          className="highlight-block-bg leaderboard-intro-bg"
        />

        {sorteo?.estado === 'oculto' || (sorteo?.tipo === 'Suscriptores' && informacion?.suscriptor === 'NO') ? (
          <Grid style={{ background: '#11111d', marginTop: isMobile ? '-30%' : '-10%', width: '100%' }} />
        ) : (
          <Box style={{ width: isMobile ? '95%' : '90%', margin: '0 auto', maxWidth: 1300 }}>

            {/* Banner directo para abrir en la app móvil */}
            {isMobileDevice() && !isInsideAppWebView() && (
              <Box
                onClick={() => launchApp(window.location.pathname)}
                sx={{
                  background: 'linear-gradient(135deg, rgba(83, 252, 24, 0.15) 0%, rgba(168, 85, 247, 0.22) 100%)',
                  border: '1px solid rgba(83, 252, 24, 0.45)',
                  borderRadius: '16px',
                  p: 1.6,
                  mb: 2.5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 1.5,
                  cursor: 'pointer',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5), 0 0 12px rgba(83, 252, 24, 0.2)',
                  transition: 'transform 0.2s ease',
                  '&:active': { transform: 'scale(0.98)' },
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
                  <Typography sx={{ fontSize: '1.6rem' }}>🎯</Typography>
                  <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ color: '#53FC18', fontWeight: 800, fontSize: '0.92rem', lineHeight: 1.2 }}>
                      Abrir en la App D-SIDE
                    </Typography>
                    <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.75rem', mt: 0.3 }}>
                      Tocá acá para unirte directamente desde la aplicación
                    </Typography>
                  </Box>
                </Box>
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    background: 'linear-gradient(135deg, #3DDC84 0%, #53FC18 100%)',
                    color: '#000',
                    fontWeight: 800,
                    borderRadius: '10px',
                    textTransform: 'none',
                    fontSize: '0.78rem',
                    px: 1.8,
                    py: 0.6,
                    flexShrink: 0,
                    boxShadow: '0 2px 8px rgba(83, 252, 24, 0.4)',
                  }}
                >
                  Abrir App
                </Button>
              </Box>
            )}

            {/* ══ HEADER ══════════════════════════════════════════════════════ */}
            <Box style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: 24,
              flexWrap: 'wrap',
              gap: 12,
            }}>
              <Box style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <Box style={{
                  width: 48, height: 48,
                  background: 'linear-gradient(135deg,#6c63ff,#a855f7)',
                  borderRadius: 12,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 22,
                }}>
                  🎯
                </Box>
                <Box>
                  <Typography style={{ color: '#fff', fontWeight: 700, fontSize: isMobile ? 20 : 26, lineHeight: 1.2 }}>
                    {sorteo?.titulo || 'Sorteo'}
                  </Typography>
                  <Typography style={{ color: '#8b8bab', fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span>🏆</span> Premios: {sorteo?.premios}
                  </Typography>
                </Box>
              </Box>

              {/* BOTÓN ADMIN – Abrir sorteo manual */}
              {esMasterAdmin && (
                <Box style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
                  {sorteo?.tipo !== 'Manual' && (
                    <button
                      onClick={sortear}
                      style={{
                        background: 'linear-gradient(135deg,#6c63ff,#a855f7)',
                        border: 'none', borderRadius: 8, color: '#fff',
                        padding: '8px 18px', fontWeight: 700, fontSize: 13,
                        cursor: 'pointer', letterSpacing: 1,
                        boxShadow: '0 2px 12px #6c63ff55',
                      }}
                    >
                      SORTEAR
                    </button>
                  )}
                  {sorteo?.tipo === 'Manual' && (
                    <button
                      onClick={() => setMostrarSorteoManual(!mostrarSorteoManual)}
                      style={{
                        background: mostrarSorteoManual
                          ? 'linear-gradient(135deg,#ef4444,#b91c1c)'
                          : 'linear-gradient(135deg,#6c63ff,#a855f7)',
                        border: 'none', borderRadius: 8, color: '#fff',
                        padding: '8px 18px', fontWeight: 700, fontSize: 13,
                        cursor: 'pointer', letterSpacing: 1,
                        boxShadow: '0 2px 12px #6c63ff55',
                      }}
                    >
                      {mostrarSorteoManual ? 'OCULTAR PANEL' : 'ABRIR SORTEO MANUAL'}
                    </button>
                  )}
                </Box>
              )}
            </Box>


            {mostrarSorteoManual && sorteo?.tipo === 'Manual' && esMasterAdmin && (
              <Box style={{
                background: '#16162a', border: '1px solid #2a2e48',
                borderRadius: 16, padding: 24, marginBottom: 24,
              }}>
                <Typography style={{ color: '#aaa', fontSize: 13, marginBottom: 10 }}>
                  Un nombre por línea. Se elegirán {sorteo?.premios || 1} ganador/es.
                </Typography>
                <textarea
                  value={listaManual}
                  onChange={(e) => setListaManual(e.target.value)}
                  placeholder="juan123&#10;maria_kick&#10;pepe_gamer&#10;..."
                  style={{
                    width: '100%', height: 200,
                    background: '#0e0e1c', color: '#fff',
                    border: '1px solid #3a3a5c', borderRadius: 10,
                    padding: 14, fontFamily: 'monospace', fontSize: 14,
                    resize: 'vertical', boxSizing: 'border-box',
                  }}
                />
                <Box style={{ display: 'flex', gap: 10, marginTop: 14 }}>
                  <button onClick={sortearManual} style={{
                    background: 'linear-gradient(135deg,#10b981,#059669)',
                    border: 'none', borderRadius: 8, color: '#fff',
                    padding: '10px 24px', fontWeight: 700, cursor: 'pointer',
                  }}>SORTEAR</button>
                  <button onClick={() => { setListaManual(''); setMostrarSorteoManual(false); }} style={{
                    background: 'transparent', border: '1px solid #555',
                    borderRadius: 8, color: '#aaa',
                    padding: '10px 18px', cursor: 'pointer',
                  }}>Cancelar</button>
                </Box>
              </Box>
            )}

            {/* ══ BOTÓN PARTICIPAR ════════════════════════════════════════════ */}
            {!sorteo?.ganadores?.length && sorteo?.tipo !== 'Chat' && sorteo?.tipo !== 'Manual' && (
              <Box style={{ marginBottom: 20 }}>
                {sorteo?.tipo === 'ID' ? (
                  unirseSorteo ? (
                    <Typography style={{ color: '#10b981', fontWeight: 700 }}>✅ ¡Ya estás participando con tu ID!</Typography>
                  ) : (
                    <Box style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
                      <TextField
                        label="Ingresa tu ID"
                        variant="outlined"
                        value={participanteId}
                        onChange={(e) => setParticipanteId(e.target.value)}
                        size="small" type="Number"
                        sx={{
                          width: isMobile ? '100%' : 260,
                          backgroundColor: '#1e1e2e',
                          '& .MuiOutlinedInput-root': { color: '#fff', '& fieldset': { borderColor: '#555' } },
                          '& .MuiInputLabel-root': { color: '#aaa' },
                        }}
                      />
                      <Button onClick={unirse} variant="contained" color="primary" size="large">PARTICIPAR</Button>
                    </Box>
                  )
                ) : (
                  <Button
                    onClick={unirse}
                    variant="contained"
                    sx={{ backgroundColor: unirseSorteo ? '#ef4444' : '#6c63ff', color: '#fff', fontWeight: 700 }}
                  >
                    {unirseSorteo ? '✅ YA ESTÁS PARTICIPANDO' : 'PARTICIPAR'}
                  </Button>
                )}
              </Box>
            )}

            {/* ══ DOS COLUMNAS: PARTICIPANTES + GANADORES ══════════════════════ */}
            <Box style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: 16,
              alignItems: 'flex-start',
            }}>

              {/* ── COLUMNA PARTICIPANTES ────────────────────────────────── */}
              {sorteo?.tipo !== 'Manual' && (
                <Box style={{
                  flex: 1,
                  background: '#13132b',
                  borderRadius: 18,
                  border: '1px solid #2a2e48',
                  overflow: 'hidden',
                  minWidth: 0,
                }}>
                  {/* header participantes */}
                  <Box style={{
                    padding: '18px 20px 14px',
                    borderBottom: '1px solid #1e1e38',
                    display: 'flex', alignItems: 'center', gap: 10,
                  }}>


                    <PeopleAltIcon style={{ color: 'white' }} />
                    <Typography style={{ color: '#fff', fontWeight: 700, fontSize: 16 }}>Participantes</Typography>
                    <Box style={{
                      marginLeft: 6,
                      background: '#6c63ff',
                      borderRadius: 20,
                      padding: '2px 10px',
                      fontSize: 12, fontWeight: 700, color: '#fff',
                    }}>
                      {participantes?.length || 0}
                    </Box>
                  </Box>

                  {/* buscador */}
                  <Box style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e38' }}>
                    <Box style={{
                      display: 'flex', alignItems: 'center',
                      background: '#0e0e1e', borderRadius: 10,
                      border: '1px solid #2a2e48', padding: '7px 14px', gap: 8,
                    }}>
                      <span style={{ color: '#555', fontSize: 15 }}>🔍</span>
                      <input
                        value={busqueda}
                        onChange={e => setBusqueda(e.target.value)}
                        placeholder="Buscar participante..."
                        style={{
                          background: 'transparent', border: 'none', outline: 'none',
                          color: '#ccc', fontSize: 13, width: '100%',
                        }}
                      />
                    </Box>
                  </Box>

                  {/* tabla header */}
                  <Box style={{
                    display: 'grid', gridTemplateColumns: '40px 1fr 130px',
                    padding: '8px 20px',
                    borderBottom: '1px solid #1e1e38',
                  }}>
                    <Typography style={{ color: '#555', fontSize: 11, fontWeight: 700, letterSpacing: 1 }}>#</Typography>
                    <Typography style={{ color: '#555', fontSize: 11, fontWeight: 700, letterSpacing: 1 }}>USUARIO</Typography>
                    <Typography style={{ color: '#555', fontSize: 11, fontWeight: 700, letterSpacing: 1, textAlign: 'right' }}>📅 FECHA</Typography>
                  </Box>

                  {/* lista */}
                  <Box style={{ maxHeight: 420, overflowY: 'auto' }}>
                    {participantesFiltrados.map((u, i) => {
                      const { color, bonus } = getUserColor(messageCounts[u?.nombre] || 0);
                      const mismosFingerprint = participantes.filter(p =>
                        p.fingerprint && p.fingerprint === u.fingerprint && p.nombre !== u.nombre
                      );
                      const esMulticuenta = mismosFingerprint.length > 0;
                      let displayName = (sorteo?.tipo === 'ID' && u.custom_id)
                        ? `${u.nombre} (${u.custom_id})` : u.nombre;
                      if (esMulticuenta) {
                        const otros = mismosFingerprint.map(p => p.nombre).join(', ');
                        displayName = `${displayName} (MC: ${otros})`;
                      }
                      const fechaStr = u.fecha
                        ? new Date(u.fecha).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' })
                        : '';

                      return (
                        <Box
                          key={i}
                          style={{
                            display: 'grid',
                            gridTemplateColumns: '40px 1fr 130px',
                            alignItems: 'center',
                            padding: '9px 20px',
                            borderBottom: '1px solid #1a1a30',
                            background: i % 2 === 0 ? 'transparent' : '#0e0e1e22',
                            transition: 'background 0.15s',
                          }}
                        >
                          <Typography style={{ color: '#555', fontSize: 13, fontWeight: 600 }}>{i + 1}</Typography>
                          <Box style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                            <Box style={{
                              width: 30, height: 30, borderRadius: '50%',
                              background: getAvatarGradient(u.nombre),
                              display: 'flex', alignItems: 'center', justifyContent: 'center',
                              fontSize: 11, fontWeight: 700, color: '#fff', flexShrink: 0,
                            }}>
                              {getInitials(u.nombre)}
                            </Box>
                            <Typography style={{
                              color: esMulticuenta ? '#ef4444' : (color === 'black' ? '#d0d0e0' : color),
                              fontSize: 13, fontWeight: esMulticuenta ? 700 : 500,
                              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                            }}>
                              {displayName}
                              {bonus > 0 && <span style={{ color: '#f59e0b', fontSize: 11 }}> +{bonus}%</span>}
                              {u?.facebook && <FaDiscord style={{ marginLeft: 6, color: '#5865f2', verticalAlign: 'middle', fontSize: 13 }} />}
                              {u?.youtube && <FaYoutube style={{ marginLeft: 6, color: '#ff0000', verticalAlign: 'middle', fontSize: 13 }} />}
                            </Typography>
                          </Box>
                          <Typography style={{ color: '#555', fontSize: 11, textAlign: 'right' }}>{fechaStr}</Typography>
                        </Box>
                      );
                    })}
                  </Box>

                  {/* pie actualizacion */}
                  <Box style={{ padding: '10px 20px', borderTop: '1px solid #1e1e38' }}>
                    <Typography style={{ color: '#f2bb47', fontSize: 12, textAlign: 'center' }}>
                      ⏳ Colores se actualizan en: {tiempoRestante}s
                    </Typography>
                  </Box>
                </Box>
              )}

              {/* ── COLUMNA GANADORES ────────────────────────────────────── */}
              {ganadoresDisplay.length > 0 && (
                <Box style={{
                  width: isMobile ? '100%' : 360,
                  flexShrink: 0,
                  background: '#13132b',
                  borderRadius: 18,
                  border: '1px solid #2a2e48',
                  overflow: 'hidden',
                  position: 'relative',
                }}>
                  {/* trofeo decorativo */}
                  <Box style={{
                    position: 'absolute', top: 12, right: 16,
                    fontSize: 56, opacity: 0.13, pointerEvents: 'none', userSelect: 'none',
                  }}>🏆</Box>

                  {/* header ganadores */}
                  <Box style={{
                    padding: '18px 20px 14px',
                    borderBottom: '1px solid #1e1e38',
                    display: 'flex', alignItems: 'center', gap: 10,
                  }}>
                    <span style={{ fontSize: 18 }}>🏆</span>
                    <Typography style={{ color: '#fff', fontWeight: 700, fontSize: 16 }}>
                      {previewMode ? 'Vista previa Ganadores' : 'Ganadores'}
                    </Typography>
                    <span style={{ fontSize: 16 }}>🏆</span>
                  </Box>

                  {/* lista ganadores */}
                  <Box style={{ padding: '8px 0' }}>
                    {ganadoresVista.map((g, index) => {
                      const { color, bonus } = getUserColor(messageCounts[g?.nombre] || 0);
                      let displayText = g.nombre;
                      let itemColor = color === 'black' ? '#d0d0e0' : color;
                      let tagLabel = null;

                      if (g.isMulti) {
                        displayText += g.multiText;
                        itemColor = '#ef4444';
                        tagLabel = 'MC';
                      } else if (g.isReplacement) {
                        displayText = `${g.nombre} (reemplazo de ${g.replacing})`;
                        itemColor = '#10b981';
                        tagLabel = 'SUB';
                      }

                      const participante = participantes?.find(p => p.nombre === g.nombre);
                      const medalColor = getMedalColor(index);
                      const medal = getMedalEmoji(index);
                      const isTop3 = index < 3;

                      return (
                        <Box
                          key={index}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                            padding: '10px 20px',
                            borderBottom: '1px solid #1a1a30',
                            background: isTop3
                              ? `linear-gradient(90deg, ${medalColor}11 0%, transparent 100%)`
                              : 'transparent',
                            borderLeft: isTop3 ? `3px solid ${medalColor}` : '3px solid transparent',
                          }}
                        >
                          {/* número / medalla */}
                          <Box style={{ width: 28, textAlign: 'center', flexShrink: 0 }}>
                            {medal ? (
                              <span style={{ fontSize: 20 }}>{medal}</span>
                            ) : (
                              <Typography style={{ color: '#555', fontWeight: 700, fontSize: 13 }}>{index + 1}</Typography>
                            )}
                          </Box>

                          {/* avatar */}
                          <Box style={{
                            width: 36, height: 36, borderRadius: '50%',
                            background: getAvatarGradient(g.nombre),
                            border: isTop3 ? `2px solid ${medalColor}` : '2px solid #2a2e48',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 12, fontWeight: 700, color: '#fff', flexShrink: 0,
                          }}>
                            {getInitials(g.nombre)}
                          </Box>

                          {/* nombre */}
                          <Box style={{ flex: 1, minWidth: 0 }}>
                            <Typography style={{
                              color: itemColor,
                              fontWeight: isTop3 ? 700 : 500,
                              fontSize: 14,
                              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                            }}>
                              {displayText}
                              {bonus > 0 && <span style={{ color: '#f59e0b', fontSize: 11 }}> +{bonus}%</span>}
                              {participante?.facebook && <FaDiscord style={{ marginLeft: 6, color: '#5865f2', verticalAlign: 'middle', fontSize: 12 }} />}
                              {participante?.youtube && <FaYoutube style={{ marginLeft: 6, color: '#ff0000', verticalAlign: 'middle', fontSize: 12 }} />}
                            </Typography>
                            {tagLabel && (
                              <Box component="span" style={{
                                fontSize: 10, fontWeight: 700,
                                color: tagLabel === 'MC' ? '#ef4444' : '#10b981',
                                background: tagLabel === 'MC' ? '#ef444422' : '#10b98122',
                                borderRadius: 4, padding: '1px 5px', marginTop: 2, display: 'inline-block',
                              }}>
                                {tagLabel}
                              </Box>
                            )}
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>

                  {/* ver todos */}
                  {ganadoresDisplay.length > 10 && (
                    <Box
                      onClick={() => setMostrarTodosGanadores(!mostrarTodosGanadores)}
                      style={{
                        padding: '14px 20px',
                        borderTop: '1px solid #1e1e38',
                        textAlign: 'center',
                        cursor: 'pointer',
                        color: '#6c63ff',
                        fontSize: 13,
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 6,
                      }}
                    >
                      <span>ℹ️</span>
                      {mostrarTodosGanadores
                        ? 'VER MENOS'
                        : `VER TODOS LOS GANADORES (${ganadoresDisplay.length})`}
                    </Box>
                  )}
                </Box>
              )}
            </Box>
          </Box>
        )}

        {/* ══ TOAST GANADOR ═══════════════════════════════════════════════════ */}
        <Modal open={open} onClose={() => setOpen(false)}>
          <AnimatePresence>
            {open && (
              <motion.div
                initial={{ x: -300, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -300, opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="toast-container"
              >
                <div className="toast-content">
                  <div className="icon">🎉</div>
                  <div className="text">
                    <strong>{open && '¡Felicidades!'}</strong>
                    {open && <p>¡Ganaste un <strong>tipeo</strong>! 🎁</p>}
                  </div>
                  <button className="close-btn" onClick={() => setOpen(false)}>×</button>
                </div>
                <div className={open ? 'progress-bar' : 'progress-bar-error'} style={{ width: `${progress}%` }} />
              </motion.div>
            )}
          </AnimatePresence>
        </Modal>
      </Grid>
    </Nlayout>
  );
}
